import React, { useEffect, useState } from 'react'
import { Alert, Button } from 'antd'
import { Link } from 'react-router-dom'
import fetchAPI from '../../../../lib/utils/fetch-api'
import { ReviewDocument } from './result-model'
import ArrivalNotice from './arrival-notice'
import { ExcessRow } from './additional-requests-model'

export default function ArrivalWarning({ reviewId, document, disabled, onChoose, direct = false }: {
  reviewId: string; document: ReviewDocument; disabled: boolean; direct?: boolean; onChoose: (rows: ExcessRow[]) => void
}) {
  const [rows, setRows] = useState<any[]>([]), [error, setError] = useState(''), [retry, setRetry] = useState(0)
  useEffect(() => {
    let active = true
    setRows([]); setError('')
    if (!disabled && !direct) void fetchAPI(`/api/supply/reviews/${reviewId}/documents/${document.id}/arrival/preview`, {
      method: 'POST', body: JSON.stringify({ version: document.version }), timeoutMs: 240000,
    }).then(result => {
      if (!active) return
      if (result.error || result.errors) {
        const details = result.error || result.errors
        throw new Error(typeof details === 'string' ? details : Array.isArray(details) ? details.map(item => item.detail || item.message || String(item)).join(', ') : details.message || details.detail || 'Не удалось проверить остатки заявок')
      }
      if (!result.data || !Array.isArray(result.data.rows)) throw new Error('Не удалось получить результаты проверки заявок. Повторите проверку.')
      setRows(result.data.rows)
    })
      .catch(cause => { if (active) setError(cause.message || 'Не удалось проверить остатки заявок') })
    return () => { active = false }
  }, [reviewId, document.id, document.version, disabled, retry, direct])
  if (direct) return null
  const conflictingOrder = error.match(/Заказ №\s*([^\s:]+)/u)?.[1]
  return <>
    {error && <Alert type="warning" showIcon message="Остатки заявок пока не проверены" description={<>{error}{conflictingOrder && <> <Link to={`/procurement/${encodeURIComponent(conflictingOrder)}`} target="_blank" rel="noopener noreferrer">Открыть заказ № {conflictingOrder}</Link></>}</>}
      action={<Button disabled={disabled} onClick={() => setRetry(value => value + 1)}>Проверить снова</Button>} style={{ margin: '12px 0' }} />}
    <ArrivalNotice rows={rows} busy={disabled} onChoose={onChoose} />
  </>
}
